import { useQuery } from "@tanstack/react-query";
import { ApiError, api } from "../../lib/api";
import type { Session } from "../../lib/types";

export const useSession = () =>
	useQuery({
		queryKey: ["session"],
		queryFn: () => api.get<Session>("/api/me"),
		retry: (failureCount, error) =>
			error instanceof ApiError && error.isUnauthenticated ? false : failureCount < 2,
		staleTime: 5 * 60 * 1000,
	});
